import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#37474f',
                secondary: '#C0C0C0',
            }
        }
        
    }
});
